import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

interface SeriesOccurrenceScopeChooserDialogProps {
  onChooseOccurrence: () => void;
  onChooseSeries: () => void;
  onClose: () => void;
}

/**
 * Shown when the user clicks a recurring series occurrence.
 * Lets them choose whether to act on this single occurrence or the whole series.
 */
export function SeriesOccurrenceScopeChooserDialog(
  props: SeriesOccurrenceScopeChooserDialogProps
) {
  const { onChooseOccurrence, onChooseSeries, onClose } = props;

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Rediger begivenhed</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Vil du redigere denne begivenhed eller hele serien?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Annuller
        </Button>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" onClick={onChooseOccurrence}>
            Denne begivenhed
          </Button>
          <Button variant="contained" onClick={onChooseSeries}>
            Hele serien
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
